import request from "@/utils/request";

// 创建主题活动
export const createMuseumActivity = (data) => {
    return request({
        url: "/businessservice/museumActivity/create",
        method: "post",
        data: data
    })
}

// 更新主题活动
export const updateMuseumActivity = (data) => {
    return request({
        url: "/businessservice/museumActivity/update",
        method: "post",
        data: data
    })
}

// 分页查询主题活动
export const pageMuseumActivity = (data) => {
    return request({
        url: "/businessservice/museumActivity/page",
        method: "post",
        data: data
    })
}

// 查询主题活动信息
export const  infoMuseumActivity =(query) =>{
    return request({
        url: "/businessservice/museumActivity/info",
        method:"get",
        params: query
    })
}

// 删除主题活动信息
export const  deleteMuseumActivity =(query) =>{
    return request({
        url: "/businessservice/museumActivity/delete",
        method:"get",
        params: query
    })
}